module.exports = __webpack_public_path__ + "a82a121ace5b4f92da2578ba4e5de4d4.svg";